export default "__VITE_ASSET__nquIUIvO__"